// src/data/exercises/index.js

import { L1_01 } from './L1_01';
import { L1_02 } from './L1_02';
import { L1_03 } from './L1_03';
import { L1_04 } from './L1_04';
import { L1_05 } from './L1_05';
import { L1_06 } from './L1_06';
import { L1_07 } from './L1_07';

import { L2_01 } from './L2_01';
import { L2_02 } from './L2_02';
import { L2_03 } from './L2_03';
import { L2_04 } from './L2_04';
import { L2_05 } from './L2_05';
import { L2_06 } from './L2_06';
import { L2_07 } from './L2_07';

import { L3_01 } from './L3_01';
import { L3_02 } from './L3_02';
import { L3_03 } from './L3_03';
import { L3_04 } from './L3_04';
import { L3_05 } from './L3_05';
import { L3_06 } from './L3_06';
import { L3_07 } from './L3_07';

import { L4_01 } from './L4_01';
import { L4_02 } from './L4_02';
import { L4_03 } from './L4_03';
import { L4_04 } from './L4_04';
import { L4_05 } from './L4_05';
import { L4_06 } from './L4_06';
import { L4_07 } from './L4_07';

import { L5_01 } from './L5_01';
import { L5_02 } from './L5_02';
import { L5_03 } from './L5_03';
import { L5_04 } from './L5_04';
import { L5_05 } from './L5_05';
import { L5_06 } from './L5_06';
import { L5_07 } from './L5_07';

import { L6_01 } from './L6_01';
import { L6_02 } from './L6_02';
import { L6_03 } from './L6_03';
import { L6_04 } from './L6_04';
import { L6_05 } from './L6_05';
import { L6_06 } from './L6_06';
import { L6_07 } from './L6_07';

// 🔹 Gộp các bài 仕訳練習 (R1-01, R1-02, …) trong 1 file riêng
import { R1_EXERCISES } from './R1_exercises';

export const allExercises = {
  // Level 1
  'L1-01': L1_01,
  'L1-02': L1_02,
  'L1-03': L1_03,
  'L1-04': L1_04,
  'L1-05': L1_05,
  'L1-06': L1_06,
  'L1-07': L1_07,

  // Level 2
  'L2-01': L2_01,
  'L2-02': L2_02,
  'L2-03': L2_03,
  'L2-04': L2_04,
  'L2-05': L2_05,
  'L2-06': L2_06,
  'L2-07': L2_07,

  // Level 3
  'L3-01': L3_01,
  'L3-02': L3_02,
  'L3-03': L3_03,
  'L3-04': L3_04,
  'L3-05': L3_05,
  'L3-06': L3_06,
  'L3-07': L3_07,

  // Level 4
  'L4-01': L4_01,
  'L4-02': L4_02,
  'L4-03': L4_03,
  'L4-04': L4_04,
  'L4-05': L4_05,
  'L4-06': L4_06,
  'L4-07': L4_07,

  // Level 5
  'L5-01': L5_01,
  'L5-02': L5_02,
  'L5-03': L5_03,
  'L5-04': L5_04,
  'L5-05': L5_05,
  'L5-06': L5_06,
  'L5-07': L5_07,

  // Level 6
  'L6-01': L6_01,
  'L6-02': L6_02,
  'L6-03': L6_03,
  'L6-04': L6_04,
  'L6-05': L6_05,
  'L6-06': L6_06,
  'L6-07': L6_07,

  // 🔹 Nhóm bài 仕訳練習 R1-*
  ...R1_EXERCISES,
};
